<script lang="ts">
  import Badge from "$lib/ui/badge/badge.svelte";
  import { mapImpactColour } from "../../utils/securityFindings";
  import { toTitleCase } from "$lib/utils/text";
  import { Tooltip, TooltipTrigger, TooltipContent } from "$lib/ui/tooltip";
  import { SecurityFindingKind } from "$lib/models/base";
  import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";
  let { finding } = $props<{
    finding: SecurityFinding;
  }>();
</script>

<Tooltip>
  <TooltipTrigger>
    <Badge color={mapImpactColour(finding.impactLevel)}>
      {toTitleCase(finding.impactLevel)}
    </Badge>
  </TooltipTrigger>
  <TooltipContent>
    <div class="flex gap-2">
      {#if finding.securityFindingKind === SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT}
        <span class="text-sm">{finding.numberOfImpactedPrincipals} users impacted</span>
      {:else if finding.securityFindingKind === SecurityFindingKind.PUBLIC_DOCUMENT}
        <span class="text-sm">Has {finding.severityLevel} severity</span>
      {:else if finding.securityFindingKind === SecurityFindingKind.LARGE_SCALE_COLLABORATION_ON_PERSONAL_DRIVE || finding.securityFindingKind === SecurityFindingKind.PERSONAL_DRIVE_WITH_SENSITIVE_DOCUMENTS}
        <span class="text-sm">{finding.numberOfDocumentsInPersonalDrive} documents impacted</span>
      {:else if finding.securityFindingKind === SecurityFindingKind.PERMISSIONS_MANAGED_THROUGH_SECONDARY_IDENTITY}
        <span class="text-sm">{finding.totalNumberOfPermissions} permissions impacted</span>
      {:else if finding.securityFindingKind === SecurityFindingKind.DOCUMENT_ACCESSED_BY_EXTERNAL_PRINCIPAL}
        <span class="text-sm">{finding.numberOfExternalPrincipals} external principals have access to the document</span>
      {:else}
        <span class="text-sm">Unknown</span>
      {/if}
    </div>
  </TooltipContent>
</Tooltip>
